import * as urls from "./urls"
import { get, post } from "services/api"

const getActionTypes = () => {
  return get(urls.GET_ACTION_TYPES)
}

const getListUsersAudit = q => {
  return get(urls.GET_LIST_USERS.replace(":q", q))
}

const getActionsList = (query, page = 1, limit = 30) => {
  return get(urls.GET_ACTIONS_LIST, {
    params: {
      query,
      page,
      limit,
    },
  })
}

// const postOrders = async (formData, query, offset, limit = 20) => {
//   return post(urls.POST_FILTER_RASTREIO, formData, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//     params: { ...query, offset, limit },
//   })
// }

export {
  // GETS
  getActionTypes,
  getListUsersAudit,
  getActionsList,
  // POSTS
}
